import {ALGOLIA_QUERY_MAP} from 'constants/algolia';
import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';
import {localStore} from 'libs/storage/storage';

type EventType = 'click' | 'conversion' | 'view';

type AlgoliaEventType = {
    eventType: EventType;
    eventName: string;
    queryID?: string;
    objectIDs?: string[];
    positions?: number[];
    objectData?: {
        price?: number;
        discount?: number;
        quantity?: number;
    }[];
    value?: number;
    currency?: string;
};

export const ALGOLIA_USER_TYPE: Record<string, EventType> = {
    addedToCartObjectIDsAfterSearch: 'conversion',
    clickedObjectIDsAfterSearch: 'click',
    purchasedObjectIDsAfterSearch: 'conversion',
};

/**
 * Retrieves all queryID → objectIDs mappings from localStorage.
 *
 * @returns An array of objects: { queryID, objectIDs }
 */
export const getAllQueryObjects = (): {queryID: string; objectIDs: string[]}[] => {
    const map: Record<string, string[]> = JSON.parse(localStore.get(ALGOLIA_QUERY_MAP) || '{}');
    return Object.entries(map).map(([queryID, objectIDs]) => ({
        objectIDs,
        queryID,
    }));
};

/**
 * Clears the entire queryID mapping from localStorage.
 */
export const clearQueryStorage = () => {
    localStore.remove(ALGOLIA_QUERY_MAP);
};

/**
 * Function for sending Algolia analytics events via BFF.
 */
export const sendAlgoliaAnalytics = async (
    events: AlgoliaEventType[],
    customerId: number | string = 0,
) => {
    try {
        await apiConfig.instanceGusaBackend.request({
            baseURL: '/',
            data: {
                events,
                id: String(customerId),
            },
            method: 'POST',
            url: ENDPOINTS.FETCH_ALGOLIA_ANALYTICS,
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`ERROR IN ALGOLIA EVENT: ${error.message}`);
    }
};
